import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Who is Pulsewave for?',
    answer: `Pulsewave is a great fit if you:
• Want to build an engaged core, not just maximize reach
• Like letting people into your process—goals, tradeoffs, decisions
• Can define measurable outcomes and deadlines
• Want a repeatable format that works like a content series
• Already have a pocket of fans who consistently show up`
  }, {
    question: 'How much time does the Lab require?',
    answer: 'Expect to spend about 1-2 hours per week. This includes creating Pulse Markets (15-30 mins total per week) and attending the weekly cohort call (45-60 mins). Optional 1:1 check-ins are available but not required.'
  }, {
    question: 'Do I have to post a certain amount?',
    answer: 'The requirement for the stipend is 4-6 Pulse Markets total over the 4-week program. You can run more if you like, but there are no view count quotas or performance requirements.'
  }, {
    question: 'How many creators are in the cohort?',
    answer: 'The founding cohort is limited to 5 creators. This keeps the group small enough for direct support and meaningful feedback while testing Pulse Markets together.'
  }, {
    question: 'What platforms work best?',
    answer: 'Pulsewave is platform-agnostic. It works great with YouTube, Twitch, Instagram, TikTok, and X. You simply share the link to your market wherever your audience is.'
  }, {
    question: 'What does "Points" mean?',
    answer: 'Points are used to "Share your Take" and track your performance and reputation on the platform. Takes and results are recorded using on-chain transactions to preserve integrity, discourage manipulation, and allow users to build portable reputation over time. Points can be claimed for rewards, perks, and drops. They are not cash, winnings, or gambling—they\'re a way to compete, build status, and earn recognition.'
  }, {
    question: 'Is this gambling?',
    answer: 'No. Pulsewave uses virtual Points only. There is no cash-in or cash-out functionality. It is designed purely for community engagement, entertainment, and building reputation.'
  }, {
    question: 'What if a market flops?',
    answer: 'That\'s okay! The Lab is a safe space to experiment. Not every market will go viral. We want to learn what works best for your specific community, and "flops" are valuable learning opportunities.'
  }];
  return <section id="faq" className="max-w-3xl mx-auto px-6 py-20 lg:py-32" data-id="element-190">
      <div className="text-center mb-16" data-id="element-191">
        <h2 className="text-4xl lg:text-5xl font-bold mb-4" data-id="element-192">FAQ</h2>
        <p className="text-slate-400" data-id="element-193">
          Common questions about the Creator Lab.
        </p>
      </div>

      <div className="space-y-4" data-id="element-194">
        {faqs.map((faq, index) => <div key={index} className="bg-navy-900 rounded-xl border border-slate-800 overflow-hidden" data-id="element-195">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-800/30 transition-colors" aria-expanded={openIndex === index} data-id="element-196">
              <span className="text-lg font-semibold pr-8 text-slate-200" data-id="element-197">
                {faq.question}
              </span>
              <ChevronDown className={`w-5 h-5 text-mint-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-198" />
            </button>

            <AnimatePresence data-id="element-199">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-200">
                  <div className="px-6 pb-5" data-id="element-201">
                    <p className="text-slate-400 leading-relaxed border-t border-slate-800/50 pt-4 whitespace-pre-line" data-id="element-202">
                      {faq.answer}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}